//user auth actions
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const CHECK_USER_STATUS = 'CHECK_USER_STATUS';
